/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updating_CardInputs */

const en_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating card...`)
};

const fr_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour de la carte...`)
};

const de_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karte wird aktualisiert...`)
};

const it_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento della scheda...`)
};

const ru_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление карты...`)
};

const es_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizando tarjeta...`)
};

const zh_cn2_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在更新卡片...`)
};

const ja_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カードを更新しています...`)
};

const hi_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्ड अपडेट हो रहा है...`)
};

const pt_pt2_updating_card = /** @type {(inputs: Updating_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizando o cartão...`)
};

/**
* | output |
* | --- |
* | "Updating card..." |
*
* @param {Updating_CardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const updating_card = /** @type {((inputs?: Updating_CardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updating_CardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_updating_card(inputs)
	if (locale === "de") return de_updating_card(inputs)
	if (locale === "it") return it_updating_card(inputs)
	if (locale === "ru") return ru_updating_card(inputs)
	if (locale === "es") return es_updating_card(inputs)
	if (locale === "zh-CN") return zh_cn2_updating_card(inputs)
	if (locale === "ja") return ja_updating_card(inputs)
	if (locale === "hi") return hi_updating_card(inputs)
	if (locale === "pt-PT") return pt_pt2_updating_card(inputs)
	return en_updating_card(inputs)
});